import axios from "axios";
import store from "../../store/index";
import TenantModel from "./TenantModel.vue";
import TenantLicenseModel from "../TenantLicense/tenantlicenseModel.vue";

export default {
  name: 'Tenant',

  components: {
    TenantModel,
    TenantLicenseModel
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      isLoading: false,
      tenantsList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      sortProperty: 'displayOrder',
      sortOrder: 1,
      expandedRows: [],
      filters: {
      search: '',
      region: '',
      environment: '',
      status: '',
      tenantCode: '',
    },
    }
  },

  computed: {
    headers() {
      return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.idToken}`,
      }
    },

    totalPages() {
      return Math.max(Math.ceil(this.totalCount / this.pageSize), 1);
    },

    pageStart() {
      return this.totalCount === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
    },

    pageEnd() {
      return Math.min(this.currentPage * this.pageSize, this.totalCount);
    },

    filteredTenants() {
      const q = (this.filters.search || '').trim().toLowerCase();
      const reg = (this.filters.region || '').trim().toLowerCase();
      const env = (this.filters.environment || '').trim().toLowerCase();
      const stat = (this.filters.status || '').trim().toLowerCase();
      const code = (this.filters.tenantCode || '').trim().toLowerCase();

      return this.tenantsList.filter(item => {
        if (q) {
          const mName = (item.tenantName || '').toLowerCase().includes(q);
          const mCode = (item.tenantCode || '').toLowerCase().includes(q);
          const mEmail = (item.rootUserEmail || '').toLowerCase().includes(q);
          if (!mName && !mCode && !mEmail) return false;
        }
        if (reg && (item.region || '').toLowerCase() !== reg) return false;
        if (env && (item.environment || '').toLowerCase() !== env) return false;
        if (stat) {
          const isActive = item.active ? 'active' : 'inactive';
          if (isActive !== stat) return false;
        }
        if (code && !(item.tenantCode || '').toLowerCase().includes(code)) return false;
        return true;
      });
    },
  },

  methods: {
    async fetchModules(page) {
      const targetPage = page || this.currentPage;
      this.isLoading = true;
      try {
        const params = {
          pageindex: targetPage,
          pagesize: this.pageSize,
          SortProperty: this.sortProperty,
          SortOrder: this.sortOrder,
        };

        if (this.filters.search) params.search = this.filters.search;
        if (this.filters.region) params.region = this.filters.region;
        if (this.filters.environment) params.environment = this.filters.environment;
        if (this.filters.status) params.status = this.filters.status;
        if (this.filters.tenantCode) params.tenantCode = this.filters.tenantCode;

        const response = await axios.get(`${this.baseUrl}/admin/tenant/getalltenant`, {
          headers: this.headers,
          params: params
        });

        const entities = response.data.entities || [];
        this.totalCount = response.data.totalCount || 0;

        this.tenantsList = entities.map(item => ({
          id: item.id,
          organizationId: item.organizationId,
          tenantName: item.tenantName,
          tenantCode: item.tenantCode,
          url: item.url,
          authTenantId: item.authTenantId,
          connectionString: item.connectionString,
          active: item.isActive,
          isDeleted: item.isDeleted,
          rootUserEmail: item.rootUserEmail,
          rootUserName: item.rootUserName,
          welcomeText: item.welcomeText,
          logoUrl: item.logoUrl,
          region: item.region,
          environment: item.environment,
          licenseId: item.licenseId,
        }));

        this.currentPage = targetPage;

        if (this.tenantsList.length === 0 && this.currentPage > 1) {
          this.fetchModules(this.currentPage - 1);
          return;
        }

      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to fetch Tenant List';
        alert(`Error: ${message}`);
        console.error('Error fetching Tenant List:', error);
      } finally {
        this.isLoading = false;
      }
    },

    openAddModule() {
      this.$refs.TenantModel.openTenantModel();
    },

    openEditModule(tenant) {
      this.$refs.TenantModel.openTenantModel(tenant);
    },

    onTenantModelSaved() {
      this.fetchModules(this.currentPage);
    },

    async deleteModule(tenant) {
      if (!confirm(`Delete tenant "${tenant.tenantName}"? This cannot be undone.`)) {
        return;
      }

      try {
        await axios.delete(`${this.baseUrl}/admin/tenant/deletetenant?id=${encodeURIComponent(tenant.id)}`, {
          headers: this.headers
        });
        alert('Tenant deleted successfully');
        this.fetchModules(this.currentPage);
      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to delete Tenant';
        alert(`Error: ${message}`);
        console.error('Error deleting Tenant:', error);
      }
    },

    onActions(tenant) {
      this.$emit('module-actions', tenant);
    },

    openLicenseModal(item) {
      this.$refs.TenantLicenseModel.openModal(item);
    },

    isExpanded(id) {
      return this.expandedRows.indexOf(id) !== -1;
    },

    toggleDescription(id) {
      const idx = this.expandedRows.indexOf(id);
      if (idx === -1) {
        this.expandedRows.push(id);
      } else {
        this.expandedRows.splice(idx, 1);
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }
      this.fetchModules(page);
    },

    prevPage() {
      this.goToPage(this.currentPage - 1);
    },

    nextPage() {
      this.goToPage(this.currentPage + 1);
    },

    applyFilters() {
      this.fetchModules(1);
    },

    resetFilters() {
      this.filters = {
        search: '',
        region: '',
        environment: '',
        status: '',
        tenantCode: '',
      };
      this.fetchModules(1);
    },
  },

  mounted() {
    this.fetchModules(1);
  },
}